import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableColumn from "./types/order-optimizer-taxi-details-hidden-details-center-tables-table-column";

const getColumns =
  (): OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableColumn[] => {
    const tableColumns: OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableColumn[] =
      [
        {
          header: "",
          title: "",
          accessor: "orders",
          colSpan: 7,
        },
        {
          header: "",
          title: "",
          accessor: "driver",
          colSpan: 3,
        },
      ];

    return tableColumns;
  };

const orderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableHelper = {
  getColumns,
};

export default orderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableHelper;
